// client/ui/StudentCoordinatorCoPilot.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class StudentCoordinatorCoPilot extends ComponentBase {
    constructor(config) {
        super(config);
        this.coPilotComponent = null;
    }

    async initialize() {
        await super.initialize();
        // Configuration will be done in initAfterLogin to ensure context is available
    }

    async initAfterLogin() {
        // AgentName should match the definition in server/ai/agents/CoordinatorAgent.js
        const agentName = "CoordinatorAgent";
        const currentUserId = this.appClient.getSharedData('userId');

        if (!currentUserId) {
            this.log.error("StudentCoordinatorCoPilot: Cannot initialize AiCoPilot without a userId.");
            return;
        }

        this.coPilotComponent = await this.createManagedComponent(
            'AdvancedAIWorkspace',
            null,
            {
                instanceId: `${this.config.instanceId || 'studentCoordinator'}-aicopilot`,
                agentName: agentName,
                singleAgentMode: true,
                height: 'container'
            }
        );
        // Re-render if the container already exists
        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'student-coordinator-copilot-container h-100 d-flex flex-column';
        }
        this.container.innerHTML = '';

        if (this.coPilotComponent) {
            const coPilotElement = await this.coPilotComponent.render();
            this.container.appendChild(coPilotElement);
        } else {
            const loadingDiv = document.createElement('div');
            loadingDiv.className = 'p-3 text-center text-muted';
            loadingDiv.textContent = this.t('Loading Coordinator...');
            this.container.appendChild(loadingDiv);
        }

        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.coPilotComponent?.destroy();
        this.coPilotComponent = null;
        super.destroy();
    }
}